import React from 'react';
import { CaretDown } from '@phosphor-icons/react';
import { cn } from '../lib/utils';

/** Native, keyboard-accessible disclosure for secondary record metadata. */
export default function CompactDetails({
  children,
  label = 'Details',
  className,
  summaryClassName,
  contentClassName,
}) {
  if (!children) return null;

  return (
    <details className={cn('group', className)}>
      <summary
        className={cn(
          'inline-flex cursor-pointer list-none items-center gap-1 rounded-md px-1 py-1 text-xs font-medium text-muted-foreground',
          'hover:bg-muted hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
          '[&::-webkit-details-marker]:hidden',
          summaryClassName
        )}
      >
        <CaretDown className="h-3.5 w-3.5 -rotate-90 transition-transform group-open:rotate-0" aria-hidden="true" />
        {label}
      </summary>
      <div className={cn('mt-2 text-sm text-muted-foreground', contentClassName)}>{children}</div>
    </details>
  );
}
